import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { JobComment, HttpResponse } from "@/types";

export function useGetJobComments() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: ["job-comments", currentCompanyId, currentJobId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/job-comments`;
      const res = await guacHttpClient.get<
        JobComment[],
        HttpResponse<JobComment[]>
      >(path);
      return res.data;
    },
  });
}
